import APIService from "../Core/APIService";
import API_ROUTES from "../../ConfigFiles/Routes/api_routes";

export interface SearchMaskedPatientParams {
  query?: string;
}

export default class AgendaSearch extends APIService {
  /**
   * Search patient name masked by query string.
   * @param {SearchMaskedPatientParams} options - Object containing search parameters.
   * @returns {Promise<string | null>} The returned name (full or masked), or null if not found (404).
   */
  async searchMaskedPatientName({
    query = "",
  }: SearchMaskedPatientParams = {}): Promise<string | null> {
    if (!query || !query.trim()) {
      return null;
    }

    try {
      // 1. Build the endpoint URL using your path function
      const url = API_ROUTES.search_patient_name_masked(query);

      // 2. Call the backend API using your inherited APIService GET method
      const response = await this.get<string>(url);

      return response;
    } catch (error: any) {
      // 3. Catch 404 (User not found) gracefully without breaking UI execution
      if (error?.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }
}